import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch";

// redux
import { useSelector, useDispatch } from "react-redux";
import { loadOverallToggleState } from "store/features/analysisResultsSlice";

function OverallToggleComponent() {
    const dispatch = useDispatch();

    const overallToggle = useSelector((state) => state.analysisResultsStore.overallToggle);

    const handleOverallToggleChange = () => {
        dispatch(loadOverallToggleState(!overallToggle));
    };

    return (
        <Button
            size="small"
            className={"custom-btn custom-btn-outlined-2 color-blue me-4 bold-content"}
            variant="outlined"
        >
            Overall
            <Switch
                size="small"
                checked={overallToggle}
                onChange={handleOverallToggleChange}
            />
        </Button>
    );
}

export default OverallToggleComponent;
